import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableStructuralAnalysis = Loadable({
  loader: () => import('./StructuralAnalysis'),
  loading: Loader
});
